import { createFileRoute } from "@tanstack/react-router";
import { TaskOptions } from "lib/components/builders/communities/tasks/TaskOptions";
import { useEstimationTask } from "lib/components/builders/communities/utils/useTasksAPI";
import { FetchErrorMessage } from "lib/components/errors/FetchErrorMessage";
import Page from "lib/components/layout/Page";
import { useAppRouterParams } from "lib/routeHelpers";
import Loading from "ui/components/Loading";
import withAuthentication from "web/components/withAuthentication";

function TaskOptionsPageReady() {
  const { builderId, taskId } = useAppRouterParams();

  if (!builderId || !taskId) {
    return null;
  }

  return <TaskOptionsPage builderId={builderId} taskId={taskId} />;
}

function TaskOptionsPage({ builderId, taskId }: { builderId: string; taskId: string }) {
  const {
    data: estimationTask,
    loading: loadingEstimationTask,
    error: errorEstimationTask,
  } = useEstimationTask({ builderId, taskId });

  return (
    <Page
      pageTitle={
        estimationTask?.name ? `Configure Options - ${estimationTask.name}` : "Loading Estimation Job Options..."
      }
    >
      {loadingEstimationTask && <Loading />}
      {errorEstimationTask && <FetchErrorMessage fetchError={errorEstimationTask} />}
      {estimationTask && <TaskOptions estimationTask={estimationTask} />}
    </Page>
  );
}

export const Route = createFileRoute("/builders/$builder_id/tasks/$task_id/options")({
  component: withAuthentication(TaskOptionsPageReady, {
    permissions: ["VIEW_OPTION_CATALOG"],
    features: ["estimationTasks"],
  }),
});
